import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { number, string } from 'prop-types'
import { down } from 'styled-breakpoints'
import { gsap } from 'gsap'

import image1 from '../../assets/images/circle1.png'
import image2 from '../../assets/images/circle2.png'
import image3 from '../../assets/images/circle3.png'
import { TABLET } from '../../lib/constant'

export default function MissionSection() {
	const sectionRef = useRef(null)
	useEffect(() => {
		if (!sectionRef.current) {
			return
		}
		const timeline = gsap.timeline({
			scrollTrigger: {
				trigger: sectionRef.current,
				toggleActions: 'play pause restart reset',
				start: '-=100% start',
			},
		})

		timeline
			.to('.circle', {
				scale: 1,
				autoAlpha: 1,
				ease: 'Power3.easeOut',
				duration: 0.5,
			})
			.set({}, {}, '+=0.5')
			.to('.circle', {
				scale: 0,
				autoAlpha: 0,
				ease: 'Power3.easeOut',
				duration: 0.5,
			})

		return () => {
			timeline.kill()
		}
	}, [])

	return (
		<Section ref={sectionRef}>
			<Content>
				<Text>
					간편하고 쉽게 <br /> 모두가 이용하는 <br /> 모두를 위한 모빌리티
				</Text>
				<Images>
					<ImageWrapper className="circle">
						<img src={image1} alt="mission" />
					</ImageWrapper>
					<ImageWrapper className="circle">
						<img src={image2} alt="mission" />
						<Circle size={36} color="#FF6D60" className="circle circle1" />
					</ImageWrapper>
					<ImageWrapper className="circle">
						<Circle size={44} color="#B90C46" className="circle circle2" />
						<Circle size={36} color="#FFDC60" className="circle circle3" />
						<img src={image3} alt="mission" />
					</ImageWrapper>
					<Circle size={83} color="#FF6D60" className="circle circle4" />
					<Circle size={22} color="#B9FF60" className="circle circle5" />
				</Images>
			</Content>
		</Section>
	)
}

const Circle = ({ size, color, className }) => (
	<CircleBlock
		width={size}
		height={size}
		viewBox={`0 0 ${size} ${size}`}
		xmlns="http://www.w3.org/2000/svg"
		fill={color}
		className={className}
	>
		<circle cx={size / 2} cy={size / 2} r={size / 2} />
	</CircleBlock>
)

Circle.propTypes = {
	size: number.isRequired,
	color: string.isRequired,
	className: string.isRequired,
}

const CircleBlock = styled.svg`
	position: absolute;
	transform: scale(0);
	opacity: 0;

	&.circle1 {
		top: 40%;
		right: -7%;
	}
	&.circle2 {
		bottom: 10%;
		left: -7%;
		z-index: 1;
	}
	&.circle3 {
		bottom: -5%;
		left: -4%;
	}
	&.circle4 {
		bottom: 12%;
		left: 18%;
	}
	&.circle5 {
		bottom: 25%;
		left: 24%;
	}

	${down(TABLET)} {
		&.circle1 {
			top: 40%;
			right: -7%;
		}
		&.circle2 {
			bottom: 10%;
			left: -7%;
			z-index: 1;
		}
		&.circle3 {
			bottom: -5%;
			left: -4%;
		}
		&.circle4 {
			bottom: 12%;
			left: -8%;
		}
		&.circle5 {
			bottom: 19%;
			left: 15%;
		}
	}
`

const Section = styled.section`
	background-color: #fafafa;
	width: 100%;
	box-sizing: border-box;
	overflow: hidden;
	padding: 0 16px;
	margin-top: 196px;
`

const Content = styled.div`
	max-width: 1440px;
	width: 100%;
	height: 100%;
	margin: 0 auto;
	position: relative;
	padding: 245px 0;
	box-sizing: border-box;
`

const Text = styled.h2`
	color: #131313;
	font-size: 72px;
	line-height: 80px;
	font-weight: 700;
	margin-top: 16px;
	text-align: center;
	position: relative;
	z-index: 2;
	${down(TABLET)} {
		font-size: 48px;
		line-height: 56px;
	}
`

const Images = styled.ul`
	position: absolute;
	height: 100%;
	width: 100%;
	top: 0;
	left: 0;
`

const ImageWrapper = styled.li`
	position: absolute;
	width: 50%;
	transform: scale(0);

	&:first-child {
		right: -48px;
		bottom: -74px;
		width: 347px;
		height: 347px;
	}
	&:nth-child(2) {
		left: -50px;
		top: 115px;
		width: 300px;
		height: 300px;
	}
	&:nth-child(3) {
		right: 130px;
		top: -32px;
		width: 169px;
		height: 169px;
	}

	> img {
		width: 100%;
		height: auto;
	}

	${down(TABLET)} {
		&:first-child {
			width: 200px;
			height: 200px;
			right: -28px;
			bottom: -44px;
		}
		&:nth-child(2) {
			left: -50px;
			top: -15px;
			width: 183px;
			height: 183px;
		}
		&:nth-child(3) {
			right: -40px;
			top: -42px;
			width: 169px;
			height: 169px;
		}
	}
`
